
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalError as ObiBatteryHorizontalErrorElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-error.js';
 
 
 

 
 export const ObiBatteryHorizontalError = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-error',
   elementClass: ObiBatteryHorizontalErrorElement,
   events: {
     
   }
  });
 
 